import React from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import {useRexAI} from "../../context/RexAIProvider";
import {useOpenInMaestroStyles} from "./buttonStyles";

const OpenInMaestroButton = ({message, label = "Open in Maestro", onOpen, cooldown = 5}) => {
  const {
    shouldShowMaestro,
    setPendingAutoSend,
    cooldownLeft,
    setCooldownLeft,
    setSessionId,
    setAgentPanelState,
  } = useRexAI();
  const {classes} = useOpenInMaestroStyles();

  if (!shouldShowMaestro) {
    return null;
  }

  const onClick = () => {
    if (cooldownLeft > 0) {
      return;
    }
    setSessionId(null);
    setAgentPanelState("list");
    setPendingAutoSend(message);
    setCooldownLeft(cooldown);
    if (onOpen) {
      onOpen();
    }
  };

  return (
    <Button
      type="button"
      id="open-in-maestro"
      variant="outlined"
      size="small"
      color="primary"
      className={classes.button}
      onClick={onClick}
      disabled={cooldownLeft > 0}
    >
      {label}
    </Button>
  );
};

OpenInMaestroButton.propTypes = {
  message: PropTypes.string.isRequired,
  label: PropTypes.string,
  onOpen: PropTypes.func,
  cooldown: PropTypes.number,
};

export default OpenInMaestroButton;
